import React, { useState, useEffect, useContext } from 'react'
import { appContext } from '../../../App'
import ReceiptsListHeader from './ReceiptsListHeader'
import ReceiptsListInner from './ReceiptsListInner'
import ReceiptsListFooter from './ReceiptsListFooter'
import { getReceiptById, getReceiptsList, getReceiptsListSettings,
  saveReceiptsListSettings } from '../ReceiptFunctions'

export const receiptsListControllerContext = React.createContext()

function useReceiptsListController() {
  const app = useContext(appContext)
  const [receiptsList, setReceiptsList] = useState([])
  const [receiptsListCopy, setReceiptsListCopy] = useState([])
  const [receiptsListSettings, setReceiptsListSettings] = useState(null)
  const [receiptsListSorted, setReceiptsListSorted] = useState(false)
  const [startSlice, setStartSlice] = useState(0)
  const [endSlice, setEndSlice] = useState(0)
  const [sortBy, setSortBy] = useState(null)

  // For footer
  const [recordPerPage, setRecordPerPage] = useState(0)
  const [recPP, setRecPP] = useState(0)
  const [page, setPage] = useState(1)
  const [totalPage, setTotalPage] = useState(0)

  const updateReceiptsListSettings = async (settings) => {
    await saveReceiptsListSettings(app, settings)
    refreshList()
  }

  const sortReceiptsListBy = (column) => {
    const sortByReceiptDate = () => {
      receiptsList.sort((a, b) => {
        let sorted
        if (!receiptsListSorted)
          sorted = ((new Date(a.date_time_created).getTime()) - (new Date(b.date_time_created).getTime()))
        else
          sorted = ((new Date(b.date_time_created).getTime()) - (new Date(a.date_time_created).getTime()))
        return sorted
      })
    }

    const sortByReceiptNumber = () => {
      receiptsList.sort((a, b) => {
        let x, y
        if (!receiptsListSorted) {
          x = a._id.toLowerCase()
          y = b._id.toLowerCase()
        } else {
          x = b._id.toLowerCase()
          y = a._id.toLowerCase()
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    const sortByReceiptFor = () => {
      receiptsList.sort((a, b) => {
        let x, y
        if (!receiptsListSorted) {
          x = a.receipt_for.item_name.toLowerCase()
          y = b.receipt_for.item_name.toLowerCase()
        } else {
          x = b.receipt_for.item_name.toLowerCase()
          y = a.receipt_for.item_name.toLowerCase()
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    const sortByReceiptAmount = () => {
      receiptsList.sort((a, b) => {
        let sorted
        if (!receiptsListSorted)
          sorted = (
            (parseFloat(a.amount_to_pay.total_amount) - parseFloat(a.discounts.discount_total.total_discount_amount))
            -
            (parseFloat(b.amount_to_pay.total_amount) - parseFloat(b.discounts.discount_total.total_discount_amount))
          )
        else
          sorted = (
            (parseFloat(b.amount_to_pay.total_amount) - parseFloat(b.discounts.discount_total.total_discount_amount))
            -
            (parseFloat(a.amount_to_pay.total_amount) - parseFloat(a.discounts.discount_total.total_discount_amount))
          )
        return sorted
      })
    }

    const sortByPaidBy = () => {
      receiptsList.sort((a, b) => {
        let x, y
        if (!receiptsListSorted) {
          x = (a.paid_by) ? a.paid_by.toLowerCase() : 0
          y = (b.paid_by) ? b.paid_by.toLowerCase() : 0
        } else {
          x = (b.paid_by) ? b.paid_by.toLowerCase() : 0
          y = (a.paid_by) ? a.paid_by.toLowerCase() : 0
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    const sortByPreparedBy = () => {
      receiptsList.sort((a, b) => {
        let x, y
        if (!receiptsListSorted) {
          x = (a.prepared_by) ? a.prepared_by.toLowerCase() : 0
          y = (b.prepared_by) ? b.prepared_by.toLowerCase() : 0
        } else {
          x = (b.prepared_by) ? b.prepared_by.toLowerCase() : 0
          y = (a.prepared_by) ? a.prepared_by.toLowerCase() : 0
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    switch (column) {
      case 'receipt_date': sortByReceiptDate()
        break
      case 'receipt_number': sortByReceiptNumber()
        break
      case 'receipt_for': sortByReceiptFor()
        break
      case 'receipt_amount': sortByReceiptAmount()
        break
      case 'paid_by': sortByPaidBy()
        break
      case 'prepared_by': sortByPreparedBy()
        break
      default:
    }

    setReceiptsListSorted(!receiptsListSorted)
    setReceiptsList(receiptsList)
  }

  const filterReceiptsList = (searchString) => {
    let tempReceiptsList = []
    receiptsListCopy.forEach(receipt => {
      receipt.search_string = `${receipt._id} ${receipt.receipt_for.item_name} ${receipt.paid_by} ${receipt.prepared_by}`
      receipt.search_string += ` ${(receipt.receipt_for.item_name === 'Invoice') ? receipt.receipt_for.item_id : receipt.receipt_for.item_id.customer_account_id}`
    })
    receiptsListCopy.forEach(receipt => {
      if (receipt.search_string) {
        let found = true
        searchString.split(' ').forEach((search_string_item, i) => {
          found = (found && (receipt.search_string.toLowerCase().search(search_string_item.toLowerCase()) !== -1))
        })
        if (found) tempReceiptsList.push(receipt)
      }
    })

    setReceiptsList(tempReceiptsList)
    setPage(1)
  }

  const getTotalRecords = () => receiptsList.length

  const refreshList = async () => { init() }

  const init = async () => {
    const receipts_list_settings = await getReceiptsListSettings(app)
    const receipts_list = await getReceiptsList(app, receipts_list_settings)

    setReceiptsListSettings(receipts_list_settings)
    setRecordPerPage(receipts_list_settings.record_per_page)
    setRecPP(receipts_list_settings.record_per_page)
    setReceiptsList(receipts_list)
    setReceiptsListCopy(receipts_list)
    setSortBy(null)
  }

  useEffect(() => {
    init()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

  useEffect(() => {
    // set total page
    setTotalPage(Math.ceil(getTotalRecords() / recordPerPage))

    // slice receiptsList
    setStartSlice((page - 1) * recordPerPage)
    setEndSlice(page * recordPerPage)

    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [receiptsList, recordPerPage, page])

  const obj = {
    app,
    startSlice: [startSlice, setStartSlice],
    endSlice: [endSlice, setEndSlice],
    receiptsList: [receiptsList, setReceiptsList],
    recordPerPage: [recordPerPage, setRecordPerPage],
    recPP: [recPP, setRecPP],
    page: [page, setPage],
    sortBy: [sortBy, setSortBy],
    refreshList,
    receiptsListSettings,
    totalPage,
    getTotalRecords,
    updateReceiptsListSettings,
    filterReceiptsList,
    sortReceiptsListBy,
    receiptsListSorted,
    getReceiptById
  }

  return (obj)
}

function ReceiptsListController() {
  const receiptsListController = useReceiptsListController()
  return (
    <React.Fragment>
      <receiptsListControllerContext.Provider value={receiptsListController}>
        <ReceiptsListHeader />
        <ReceiptsListInner />
        <ReceiptsListFooter />
      </receiptsListControllerContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(ReceiptsListController)